@let currentData = proccesedData();

@if (currentData) {
    <big-ui-alert
        [type]="currentData.alertType"
        [title]="currentData?.title">
        <div
            class="w-full"
            [innerHTML]="currentData?.content ?? '' | sanitize: securityContext"></div>
    </big-ui-alert>
}
